export default "__VITE_ASSET__59480672__"